/** Compact display for counts (header badges, billing). */
export function formatCompactCount(n) {
  if (n == null || Number.isNaN(Number(n))) return '0';
  const x = Number(n);
  if (x >= 1_000_000) return `${(x / 1_000_000).toFixed(1)}M`;
  if (x >= 10_000) return `${Math.round(x / 1000)}K`;
  if (x >= 1000) return `${(x / 1000).toFixed(1)}K`;
  return String(Math.round(x));
}
